<template>
  <div class="previewMail">
    <div v-if="formData.showUserName==1" class="showUserName">
      {{formData.language==1?'Dear ${UserName}':'亲爱的${UserName}'}} 
    </div>
    <div
      class="editMailBody"
      v-html="formData.content"
    ></div>
    <div v-if="attachmentVos.length>0">
      <div v-for="item in attachmentVos" :key="item.hashCode" class="downLoadBtn">
        <el-button type="primary"   @click="downLoad(item)">{{item.fileName}}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { downloadFileFun } from '@/utils/common.js'
import { fileUrl } from '@/utils/config.js'
export default {
  props:{
    formData:{
      type:Object,
      default:{}
    },
    tempUrlShow:{
      type:Boolean,
      default:false
    },
    attachmentVos:{
      type:Array,
      default:[]
    }
  },
  mounted(){
    // console.log(this.formData)
    // this.content=this.formData.content
    // this.showUserName=this.formData.showUserName
  },
  data(){
    return{
      content:'',
      showUserName:1
    }
  },
  methods:{
    downLoad(item) {
      let url=`/res/attach/download-temp?code=`
      if(item.response==undefined){
        url=`/download-static?code=`
      }else{
        url=`/res/attach/download-temp?code=`
      }
      return downloadFileFun(`${fileUrl}${url}${item.hashCode}`)
    },
  }
}
</script>
<style lang="scss" scoped>
.downLoadBtn{
  margin-top: 20px;
}
.previewMail{
  background: #ffffff;
  border: 1px solid #eeeeee;
  padding-right: 23px;
  overflow: scroll;
  height: 512px;
  padding:16px ;
  padding-right: 16px;
  .showUserName{
    margin-bottom: 10px;
  }
}
    /**修改全局的滚动条*/
  /**滚动条的宽度*/
  ::-webkit-scrollbar {
    width: 6px;
  }
  // 滚动条的滑块
  ::-webkit-scrollbar-thumb {
    background-color: rgba(144,147,153,.3);
    border-radius: 3px;
  }
  
::v-deep .editMailBody{

  div,
  span,
  object,
  li,
  ul,
  img iframe,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  pre,
  a,
  em,
  img,
  strong,
  sub,
  sup,
  b,
  i,
  dl,
  dt,
  dd,
  ol,
  ul,
  li,
  fieldset,
  form,
  label,
  legend,
  table,
  tbody,
  tfoot,
  thead,
  tr,
  th,
  td,
  article,
  aside,
  canvas,
  details,
  embed,
  figure,
  figcaption,
  footer,
  header,
  menu,
  nav,
  output,
  ruby,
  section,
  abstractDesc,
  time,
  mark,
  audio,
  video,
  input,
  textarea,
  select,
  button,
  meter,
  progress {
    margin: revert;
  }
  a {
    color: rgb(0, 0, 238) !important;
  }
  img {
    // width: 100%;
  }
}
</style>